import {
  errorAlert,
  loadingComplete,
  loadingStarted,
  successAlert,
} from "../Redux/Reducers/AppSlice";
import { signOut } from "../Redux/Reducers/UserSlice";

export const onQueryStartedDefault = async (
  id,
  { dispatch, queryFulfilled }
) => {
  dispatch(loadingStarted());
  try {
    await queryFulfilled;
    // `onSuccess` side-effect
    dispatch(loadingComplete());
  } catch (err) {
    // `onError` side-effect
    dispatch(loadingComplete());
    if (err?.error?.status === 401) {
      // if unauthorization error,logout user.
      dispatch(signOut());
      dispatch(
        errorAlert({
          message: err?.error?.data?.message
            ? err.error.data.message
            : "Session expired, please sign in again !",
        })
      );
    } else {
      dispatch(
        errorAlert({
          message: err?.error?.data?.message || "Error loading data",
        })
      );
    }
  }
};

export const onMutationStartedDefault = async (
  data,
  { dispatch, queryFulfilled }
) => {
  dispatch(loadingStarted());
  try {
    const res = await queryFulfilled;
    // `onSuccess` side-effect
    dispatch(loadingComplete());
    if (res.data.message) {
      dispatch(successAlert(res.data));
    }
  } catch (err) {
    dispatch(loadingComplete());
    if (err?.error?.status === 401) {
      // if unauthorization error,logout user.
      dispatch(signOut());
      dispatch(
        errorAlert({
          message: err?.error?.data?.message
            ? err.error.data.message
            : "Session expired, please sign in again !",
        })
      );
    } else {
      dispatch(
        errorAlert({
          message: err?.error?.data?.message || "Error completing request",
        })
      );
    }
  }
};
